

































import { Component, Mixins } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import CompanyInfo from "@/components/Company/Info.vue";
import CompaniesMixin from "@/mixins/http/CompaniesMixin";
import GeneralSettingsSelect from "@/components/GeneralSettings/Select.vue";
import GeneralSettingsMultiSelect from "@/components/GeneralSettings/MultiSelect.vue";
import { Company } from "@/models";
import CompanyShowTabs from "../Tabs.vue";

@Component({
  components: {
    Page,
    CompanyInfo,
    GeneralSettingsSelect,
    GeneralSettingsMultiSelect,
    CompanyShowTabs,
  },
})
export default class CompanyIndex extends Mixins(CompaniesMixin) {
  private company: Company | null = null;

  static readonly getCompanyTag = "create_company_tag";

  get companyLogo() {
    return {
      backgroundImage: `url(${
        this.company?.logo || require("@/assets/icons/placeholder.svg")
      })`,
    };
  }

  mounted() {
    this.loadCompany();
  }

  async loadCompany() {
    this.company = await this.getCompany(
      this.$route.params.id,
      CompanyIndex.getCompanyTag
    );
  }
}
